/* แจ้งเตือนแบบเด้ง มุมขวาบน (มือถือ = บนกลาง) — เขียนเอง ~2KB ไม่ต้องโหลดไลบรารี
   ใช้: toast.ok('เข้าสู่ระบบสำเร็จ') · toast.err('เบอร์หรือ PIN ไม่ถูกต้อง') · toast.info('...') */
const CSS = `
.nv-toasts{position:fixed;z-index:9999;top:18px;right:18px;display:flex;flex-direction:column;gap:10px;pointer-events:none}
/* มือถือ: เด้งจากล่าง (ตรงกับสายตาและนิ้ว) ยกให้พ้นแถบเมนูล่างถ้ามี */
@media(max-width:640px){.nv-toasts{left:12px;right:12px;top:auto;bottom:calc(14px + env(safe-area-inset-bottom) + var(--nv-bottom,0px));align-items:stretch;flex-direction:column-reverse}}
.nv-toast{pointer-events:auto;display:flex;align-items:center;gap:11px;min-width:250px;max-width:min(380px,92vw);
  padding:13px 16px;border-radius:14px;color:#fff;font:600 14px/1.45 inherit;
  background:rgba(18,14,26,.94);border:1px solid rgba(255,255,255,.14);
  box-shadow:0 14px 40px rgba(0,0,0,.45);backdrop-filter:blur(10px);
  transform:translateX(120%);opacity:0;transition:transform .38s cubic-bezier(.22,1.4,.4,1),opacity .3s}
@media(max-width:640px){.nv-toast{transform:translateY(140%)}}
.nv-toast.in{transform:none;opacity:1}
.nv-toast i{flex:none;width:30px;height:30px;border-radius:50%;display:grid;place-items:center;font-style:normal;font-size:16px;animation:nvpop .45s cubic-bezier(.22,1.4,.4,1)}
.nv-toast.ok i{background:linear-gradient(135deg,#34d399,#059669)}
.nv-toast.err i{background:linear-gradient(135deg,#fb7185,#e11d48)}
.nv-toast.info i{background:linear-gradient(135deg,#a78bfa,#7c3aed)}
.nv-toast small{display:block;font-weight:400;opacity:.75;font-size:12px;margin-top:1px}
.nv-toast b{font-weight:700}
@keyframes nvpop{0%{transform:scale(.3);opacity:0}60%{transform:scale(1.15)}100%{transform:scale(1);opacity:1}}
.nv-toast:after{content:"";position:absolute;left:0;right:0;bottom:0;height:2px;border-radius:0 0 14px 14px;
  background:linear-gradient(90deg,rgba(255,255,255,.5),transparent);transform-origin:left;animation:nvbar var(--ms,2600ms) linear forwards}
@keyframes nvbar{to{transform:scaleX(0)}}
`;

function box() {
  if (typeof document === 'undefined') return null;
  let el = document.querySelector('.nv-toasts');
  if (!el) {
    const st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    el = document.createElement('div');
    el.className = 'nv-toasts';
    document.body.appendChild(el);
  }
  // แถบเมนูล่างของมือถือบังพอดี — วัดความสูงจริงแล้วยกขึ้นให้พ้น
  if (window.innerWidth <= 640) {
    const bar = document.querySelector('.mbar, .bottom-nav, .mobile-nav, .np-bottom-nav, [class*="bottomnav"]');
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    el.style.setProperty('--nv-bottom', (h > 20 && h < 140 ? h : 0) + 'px');
  }
  return el;
}

function show(kind, title, sub, ms = 2600) {
  const wrap = box();
  if (!wrap) return;
  const t = document.createElement('div');
  t.className = `nv-toast ${kind}`;
  t.style.position = 'relative';
  t.style.setProperty('--ms', ms + 'ms');
  t.innerHTML = `<i>${kind === 'ok' ? '✓' : kind === 'err' ? '!' : 'i'}</i><span><b></b>${sub ? '<small></small>' : ''}</span>`;
  t.querySelector('b').textContent = title;
  if (sub) t.querySelector('small').textContent = sub;
  t.onclick = () => close();
  wrap.appendChild(t);
  requestAnimationFrame(() => t.classList.add('in'));
  const close = () => { t.classList.remove('in'); setTimeout(() => t.remove(), 400); };
  setTimeout(close, ms);
}

const toast = {
  ok: (title, sub, ms) => show('ok', title, sub, ms),
  err: (title, sub, ms) => show('err', title, sub, ms || 3200),
  info: (title, sub, ms) => show('info', title, sub, ms),
};
export default toast;

/* บางเว็บโหลดตัวนับสถิติแบบ lazy (หลังผู้ใช้แตะครั้งแรก) — ถ้ายังไม่มา เก็บคิวไว้ให้ t.js มายิงเอง */
if (typeof window !== 'undefined' && !window.cmsTrack) {
  window.cmsTrackQueue = window.cmsTrackQueue || [];
  window.cmsTrack = (ev, label) => { window.cmsTrackQueue.push([ev, label]); };
}
